<div class="pt-3 pl-md-4" *ngIf="associationNotFound">
  <h2>Association not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingAssociation">
  <h2>Loading Association...</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!loadingAssociation && !associationNotFound && (serverError === null)">

  <div class="alert alert-info" role="alert" *ngIf="loadingAlerts">
    Loading alerts...
  </div>

  <div class="alert text-center" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-dismissible" role="alert"
         [class.alert-success]="callbackResult.status === CallbackResultStatus.success"
         *ngIf="callbackResult !== null">
      {{ callbackResult.text }}
      <button type="button" class="close" (click)="callbackResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <ng-container *ngIf="alerts && (alerts.length > 0) && !loadingAlerts">
    <div *ngFor="let alert of alerts"
         class="alert text-center"
         [ngStyle]="getAssociationAlertStyle(alert)">
      <button class="btn btn-outline-primary alert-dismiss-btn disabled" disabled
              *ngIf="loadingDismissAlert[alert.id]">
        Loading...
      </button>
      <button class="btn btn-outline-primary alert-dismiss-btn"
              *ngIf="!loadingDismissAlert[alert.id]"
              (click)="dismissAlert(alert)">
        Dismiss
      </button>

      {{ alert.alert_text }}
      <small class="d-block">Alert created on {{ dateStringFromISO8601(alert.created_date) }}</small>
    </div>
  </ng-container>

  <div class="row" style="min-height: 200px">
    <div class="col-md-8">
      <div class="container pt-3 rounded-border" style="height: 100%">
        <div class="float-right">
          <button class="btn btn-sm btn-outline-primary mr-2"
                  (click)="openAddAlertModal()">
            Add Alert
          </button>
          <a class="btn btn-sm btn-outline-primary"
             [routerLink]="['/associations', association.id.toString(), 'configure']">
            Configure
          </a>
        </div>
        <img *ngIf="!association.profile_image"
             src="/assets/images/photo_placeholder.png"
             class="association-photo float-left" style="margin-right: 15px;">
        <img *ngIf="association.profile_image"
             [src]="association.profile_image"
             class="association-photo float-left" style="margin-right: 15px;">
        <h2 class="mt-2">{{ association.name }}</h2>
        <h5>{{ association.num_members }} Association Member{{ (association.num_members === 1) ? '' : 's' }}</h5>
        <p class="text-muted">
          Created: {{ dateStringFromISO8601(association.created_at) }}
        </p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="container pt-3 rounded-border" style="height: 100%">
        <p class="side-table-header">Managers</p>
        <a href="#" class="side-table-add-icon"
           (click)="openAddManagerModal();$event.preventDefault();">
          +
        </a>
        <table class="table table-hover">
          <tbody *ngIf="!loadingAssociationManagers">
          <tr class="cursor-pointer" *ngFor="let manager of associationManagers"
              (click)="openEditManagerModal(manager)">
            <td class="pl-0">
              {{ manager.customer_first_name }} {{ manager.customer_last_name }}
            </td>
          </tr>
          <tr *ngIf="associationManagers.length === 0">
            <td colspan="99" class="text-muted pl-0">
              No managers
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="loadingAssociationManagers">
          <tr>
            <td colspan="99" class="text-muted pl-0">
              Loading...
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <nav class="navbar navbar-expand navbar-light bg-light rounded-border rounded-tight profile-nav mt-3"
       style="padding-left: 8px;padding-right: 0; overflow: hidden;">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link text-nowrap" href="#"
           [class.active]="subList === SubList.members"
           (click)="selectSubList(SubList.members);$event.preventDefault();">
          Members
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-nowrap" href="#"
           [class.active]="subList === SubList.discounts"
           (click)="selectSubList(SubList.discounts);$event.preventDefault();">
          Discounts
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-nowrap" href="#"
           [class.active]="subList === SubList.entryPasses"
           (click)="selectSubList(SubList.entryPasses);$event.preventDefault();">
          Entry Passes
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-nowrap" href="#"
           [class.active]="subList === SubList.activityLog"
           (click)="selectSubList(SubList.activityLog);$event.preventDefault();">
          Activity Log
        </a>
      </li>
    </ul>
  </nav>

  <app-association-members-sub-list *ngIf="subList === SubList.members"
                                    [association]="association"
                                    [resultCallback]="handleSubListResult"></app-association-members-sub-list>
  <app-association-discounts-sub-list *ngIf="subList === SubList.discounts"
                                      [association]="association"
                                      [resultCallback]="handleSubListResult"></app-association-discounts-sub-list>
  <app-association-entry-passes-sub-list *ngIf="subList === SubList.entryPasses"
                                         [association]="association"
                                         [resultCallback]="handleSubListResult"></app-association-entry-passes-sub-list>
  <app-association-activity-log-sub-list *ngIf="subList === SubList.activityLog"
                                         [association]="association"
                                         [resultCallback]="handleSubListResult"></app-association-activity-log-sub-list>

</div>
